import { render, staticRenderFns } from "./QualityInspectDefectiveList.vue?vue&type=template&id=678ac1bd&scoped=true&"
import script from "./QualityInspectDefectiveList.vue?vue&type=script&lang=js&"
export * from "./QualityInspectDefectiveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678ac1bd",
  null
  
)

export default component.exports